<template>
  <div>
    <div class="date-time-ct">
      <form-item
        prop="send_date"
        :label="$t('CampaignForm_Schedule_SendLater_Date')"
        class="date-input input"
      >
        <el-date-picker
          format="MMMM d, yyyy"
          value-format="yyyy-MM-dd"
          v-model="model.send_date"
          :picker-options="pickerOptions"
          @change="dateChanged('send_date', $event)"
        />
      </form-item>
      <form-item
        prop="send_time"
        :label="$t('CampaignForm_Schedule_SendLater_Time')"
        class="time-input input"
      >
        <el-time-picker
          format="HH:mm"
          value-format="HH:mm"
          v-model="model.send_time"
          @change="timeChanged('send_time', $event)"
        />
      </form-item>
      <form-item
        prop="timezone"
        :label="$t('CampaignForm_Schedule_SendLater_Timezone')"
        class="timezone-select"
      >
        <el-select v-model="model.timezone" filterable clearable>
          <el-option
            v-for="(label, value) in timezones"
            :key="value"
            :value="value"
            :label="label"
          >
            <span v-tooltip>{{ label }}</span>
          </el-option>
        </el-select>
      </form-item>
    </div>
    <div class="separator"></div>
    <div class="prepare-upfront-ct">
      <el-checkbox
        class="prepare-upfront-label"
        :label="$t('CampaignForm_Schedule_SendLater_PrepareUpfront')"
        v-model="model.prepare_interval_enabled"
        :true-label="1"
        :false-label="0"
      />
      <div
        v-if="model.prepare_interval_enabled"
        class="prepare-input-number-ct"
      >
        <span class="prepare-upfront-label">{{
          $t('CampaignForm_Schedule_SendLater_PrepareUpfront_Prepare')
        }}</span>
        <el-input-number
          :min="0"
          :max="99"
          :placeholder="
            $t('CampaignForm_Schedule_SendLater_PrepareUpfront_Placeholder')
          "
          :controls="false"
          v-model="model.prepare_interval"
        />
        <span class="prepare-upfront-label">{{
          $t('CampaignForm_Schedule_SendLater_PrepareUpfront_MinutesUpfront')
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'SendLaterComponent',
  components: { FormItem },

  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: 'Now',
            onClick: vm => vm.$emit('pick', new Date())
          }
        ],
        disabledDate: date => moment(date).isBefore(this.now, 'date')
      }
    }
  },

  methods: {
    dateChanged(field, newValue) {
      if (newValue === null) {
        this.$nextTick(() => {
          this.model[field] = moment()
            .tz(this.model.timezone)
            .format('Y-MM-DD')
        })
      }
    },
    timeChanged(field, newValue) {
      if (newValue === null) {
        this.$nextTick(() => {
          this.model[field] = moment()
            .tz(this.model.timezone)
            .format('HH:mm')
        })
      }
    }
  },

  computed: {
    ...mapGetters(['timezones'])
  },

  watch: {
    'model.prepare_interval_enabled': {
      handler(selection) {
        if (!selection) {
          this.model.prepare_interval = null
        }
      }
    }
  }
}
</script>

<style scoped>
>>> .el-form-item__label {
  font-weight: 600;
  line-height: 22px;
  font-size: 14px;
}

>>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #1d87c8;
  border-color: #1d87c8;
}

>>> .el-input-number {
  width: 80px;
  margin-left: 16px;
  margin-right: 16px;
}

.date-time-ct {
  display: flex;
}

.date-input {
  width: 200px;
}

.time-input {
  width: 100px;
}

.timezone-select {
  width: 300px;
}

.input {
  margin-right: 16px;
}

.prepare-upfront-ct {
  margin-top: 32px;
}

.prepare-input-number-ct {
  margin-top: 20px;
}

.prepare-upfront-label {
  color: #7e8596;
  font-size: 14px;
  line-height: 22px;
}

>>> .el-checkbox__label,
>>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #5c6374;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
.separator {
  margin: 24px -20px;
  border-top: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/SendLaterComponent.vue